import { Box, Chip, Typography } from '@material-ui/core';
import { QuotationUnit } from 'data-layer-cr/dist/models';
import {
  getChipPlanByOption,
  getTitleByOption,
} from 'src/functions/individualOptionHelpers';
import AmountSection from './AmountSection';

type OptionPriceCardResumeProps = {
  anualPrice: number;
  moneyType: string;
  createdAt?: string;
  unit: QuotationUnit;
};

export const OptionPriceCardResume = ({
  anualPrice,
  moneyType,
  createdAt,
  unit,
}: OptionPriceCardResumeProps): JSX.Element => {
  const chipPlan = getChipPlanByOption(unit.package.id);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      style={{ gap: '0.5rem' }}
    >
      <Typography variant="h2" style={{ fontSize: 23 }}>
        {getTitleByOption(unit.package.id, createdAt)}
      </Typography>
      <Chip
        label={
          <Typography
            variant="caption"
            style={{ fontSize: 15, color: chipPlan.colorText }}
          >
            {chipPlan.title}
          </Typography>
        }
        style={{
          backgroundColor: chipPlan.colorBackground,
        }}
      />
      <AmountSection anualPrice={anualPrice} moneyType={moneyType} />
    </Box>
  );
};

export default OptionPriceCardResume;
